export default [
  {
    title: 'مدیریت کاربران',
    icon: 'bx bx-user',
    children: [
      {
        title: 'کاربران',
        route: { name: 'user' },
        resource: 'UserManager',
        action: 'show',
      },
      {
        title: 'کارشناسان تغذیه',
        route: { name: 'nutritionists' },
        resource: 'NutritionistManager',
        action: 'show',
      },
      {
        title: 'نقش ها',
        route: { name: 'userrole' },
        resource: 'UserRoleManager',
        action: 'show',
      },
      // {
      //   title: 'تخصیص نقش',
      //   route: { name: 'SetRole' },
      //   icon: 'UserPlusIcon',
      //   resource: 'SetRole',
      //   action: 'show',
      // },
      // {
      //   title: 'داشبورد',
      //   route: { name: 'ecommerce' },
      //   resource: 'UserRoleManager',
      //   action: 'show',
      // },
    ],
  },
]
